import * as tslib_1 from "tslib";
import { css } from '../styles';
import Typography from '../Typography';
import paddingPropReceiver from '../styled-components-utils/prop-receivers/padding';
var noneTypePadding = css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  padding: 0;\n"], ["\n  padding: 0;\n"])));
var defaultTypePadding = css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  &:last-of-type {\n    padding-right: 24px;\n  }\n"], ["\n  &:last-of-type {\n    padding-right: 24px;\n  }\n"])));
var checkboxTypePadding = css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  padding: 0 12px;\n  width: 48px;\n"], ["\n  padding: 0 12px;\n  width: 48px;\n"])));
var TableCellPadding = css(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  padding: 4px 56px 4px 24px;\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  padding: 4px 56px 4px 24px;\n  ",
    ";\n  ",
    ";\n  ",
    ";\n"])), function (props) {
    return props.padding === 'none' && noneTypePadding;
}, function (props) {
    return props.padding === 'checkbox' && checkboxTypePadding;
}, function (props) {
    return props.padding === 'default' && defaultTypePadding;
});
var TableCellStyle = css(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  text-align: ", ";\n  border-bottom: 1px solid\n    ", ";\n\n  ", ";\n"], ["\n  text-align: ",
    ";\n  border-bottom: 1px solid\n    ",
    ";\n\n  ",
    ";\n"])), function (props) {
    return props.numeric ? 'right' : 'left';
}, function (props) {
    return props.theme.palette.type === 'light'
        ? 'rgba(224, 224, 224, 1)'
        : 'rgba(50, 50, 50, 1)';
}, function (props) {
    return props.numeric && 'flex-direction: row-reverse;';
});
var StyledTh = Typography.withComponent('th').extend.attrs({
    type: 'caption',
})(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), TableCellPadding, TableCellStyle, paddingPropReceiver);
var StyledTd = Typography.withComponent('td').extend.attrs({
    type: 'body1',
})(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), TableCellPadding, TableCellStyle, paddingPropReceiver);
export { StyledTh, StyledTd };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=TableElement.js.map